import {useMemo} from "react";
import MetricDashCard from "../../../../../../../../components/dash-card/metric-dash-card.jsx";

export default function TypeActions({ data }) {
    const actionsByType = useMemo(() => Array.isArray(data?.actions?.byType)
        ? data.actions.byType.map(item => ({
            label: item.label ?? "",
            value: Number(item.qty) || 0,
        }))
        : [], [data?.actions?.byType]);

    return (
        <article>
            <h3 className="mb-6! text-center">Tipo de ação</h3>
            <div className="grid grid-cols-3 gap-x-4 w-full h-full min-w-0 min-h-0">
                {actionsByType.map(item => (
                    <MetricDashCard
                        counterCard
                        key={item.label}
                        title={item.label}
                        value={item.value}
                        width={130}
                        height={76}
                    />
                ))}
            </div>
        </article>
    )
}
